import(/* webpackMode: "eager" */ "/app/app/[locale]/not-found.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
